import ForgottenScreen from './ForgottenScreen';

export default ForgottenScreen;
